export default "__VITE_ASSET__CQRisaXW__"